import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import './Navigation.css';

function Navigation() {
  const { user, logout } = useAuth();

  return (
    <nav className="navbar">
      <div className="nav-container">
        <Link to="/" className="nav-logo">
          SponsorBoat
        </Link>
        <ul className="nav-menu">
          <li className="nav-item">
            <Link to="/" className="nav-link">Home</Link>
          </li>
          <li className="nav-item">
            <Link to="/about" className="nav-link">About</Link>
          </li>
          <li className="nav-item">
            <Link to="/youtube" className="nav-link">YouTube</Link>
          </li>
          <li className="nav-item">
            <Link to="/instagram" className="nav-link">Instagram</Link>
          </li>
          <li className="nav-item">
            <Link to="/blog" className="nav-link">Blog</Link>
          </li>
          <li className="nav-item">
            <Link to="/submission" className="nav-link">Submit</Link>
          </li>
          <li className="nav-item">
            <Link to="/contact" className="nav-link">Contact</Link>
          </li>
          <li className="nav-item">
            <Link to="/privacy-policy" className="nav-link">Privacy</Link>
          </li>
          <li className="nav-item">
            <Link to="/terms" className="nav-link">Terms</Link>
          </li>
          {user ? (
            <li className="nav-item nav-user">
              <span className="nav-user-name">{user.name}</span>
              <button className="nav-logout-btn" onClick={logout}>Logout</button>
            </li>
          ) : (
            <li className="nav-item">
              <Link to="/login" className="nav-link nav-link-accent">Sign In</Link>
            </li>
          )}
          {user && user.is_admin ? (
            <li className="nav-item">
              <Link to="/admin/dashboard" className="nav-link">Admin Panel</Link>
            </li>
          ) : null}
        </ul>
      </div>
    </nav>
  );
}

export default Navigation;
